import { RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { pickupMessage } from "@/lib/store";

const SAMPLE = { number: "SAN-AB12CD", customer: { name: "Maria Silva" }, pickup_at: new Date(Date.now() - 4 * 86400000).toISOString() };
const BASE_TAGS = [["{nome}", "primeiro nome do cliente"], ["{pedido}", "número do pedido"], ["{endereco}", "endereço da loja"], ["{horario}", "horário de funcionamento"]];

export function MessageEditor({ id, title, hint, value, onChange, defaultValue, withDate = false }) {
  const tags = withDate ? [...BASE_TAGS, ["{data}", "dia em que ficou pronto"]] : BASE_TAGS;
  return (
    <div className="grid gap-6 lg:grid-cols-2" data-testid={`editor-${id}`}>
      <div className="space-y-4 rounded-md border border-slate-200 bg-white p-6">
        <div>
          <h2 className="font-display text-lg font-bold">{title}</h2>
          <p className="text-sm text-slate-500">{hint}</p>
        </div>
        <Textarea rows={9} value={value} onChange={(e) => onChange(e.target.value)} data-testid={`input-${id}`} />
        <div className="flex flex-wrap gap-2">
          {tags.map(([tag, label]) => (
            <button key={tag} type="button" onClick={() => onChange(`${value}${tag}`)} title={label} data-testid={`${id}-tag-${tag.slice(1, -1)}`}
              className="rounded-full border border-slate-200 px-3 py-1 font-mono text-xs hover:border-[#0099DD] hover:text-[#0099DD]">
              {tag}
            </button>
          ))}
        </div>
        <Button variant="outline" size="sm" onClick={() => onChange(defaultValue)} data-testid={`${id}-reset`}><RotateCcw className="h-4 w-4" /> Restaurar padrão</Button>
      </div>
      <div className="rounded-md bg-[#e5ddd5] p-6" data-testid={`${id}-preview`}>
        <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-slate-600">Prévia (exemplo)</p>
        <div className="max-w-sm whitespace-pre-line rounded-lg rounded-tl-none bg-white p-4 text-sm shadow">{pickupMessage(SAMPLE, value)}</div>
      </div>
    </div>
  );
}
